module.exports = {
	content: [
		{
			title: 'Commercial',
			text: 'We professional install facades of buildings, interior showrooms, bathrooms, staircases, with quality stone, limestone (facades) marble, granite or tile accordingly to the architectural plans. We make it our utmost importance to finish in the time phase planned.',
		},
		{
			title: 'Residential',
			text: 'We professional install, glass tile, granite, hand-made tiles, marble/marble slabs, quartz, soap stone, porcelain tile, and limestone, in many different patterns in a mud job.',
		},
	],

	services: [
		{
			service: 'Bathrooms',
			img: 'https://images2.imgbox.com/f0/53/k1i9bYsW_o.jpg',
		},
		{
			service: 'Back Splashes',
			img: 'https://images2.imgbox.com/39/d9/NeDs3Gso_o.jpg',
		},
		{
			service: 'Brick Ovens',
			img: 'https://images2.imgbox.com/6e/45/oKcJ9aoT_o.jpg',
		},
		{
			service: 'Churches',
			img: 'https://images2.imgbox.com/01/6e/GtUhWOEE_o.jpg',
		},
		{
			service: 'Countertops',
			img: 'https://images2.imgbox.com/39/23/sCtaH85z_o.jpg',
		},
		{
			service: 'Fireplaces',
			img: 'https://images2.imgbox.com/93/21/3FY8qdyT_o.jpg',
		},
		{
			service: 'Foyers',
			img: 'https://images2.imgbox.com/46/6c/HgcFbfu9_o.jpg',
		},
		{
			service: 'Kitchens',
			img: 'https://images2.imgbox.com/11/4a/KO0Mi6p5_o.jpg',
		},
		{
			service: 'Patios',
			img: 'https://images2.imgbox.com/3e/46/bfm2xp2s_o.jpg',
		},
		{
			service: 'Pools',
			img: 'https://images2.imgbox.com/fb/4a/7mIzGIji_o.jpg',
		},
		{
			service: 'Showrooms',
			img: 'https://images2.imgbox.com/3b/38/nG5NyfMK_o.jpg',
		},
		{
			service: 'Staircases',
			img: 'https://images2.imgbox.com/17/2a/5a06A3hz_o.jpg',
		},
	]
}
